import { DownloadButton } from './Download';
import { tl } from '../helpers';
import { useStore, show, planEls } from '../store';

export function ApprovalsView() {
  const { pending } = useStore();
  return (
    <>
      <div className="page-title">Onaylar</div><p className="page-sub">Onayınızı bekleyen teklif taslakları.</p>
      <div>
        {!pending.length
          ? <div className="empty">Onay bekleyen taslak yok. Komut merkezinden yeni bir teklif talebi yazın.</div>
          : (
            <div className="tbl-wrap"><table className="num">
              <thead><tr><th>Taslak</th><th>Müşteri</th><th className="r">Tutar</th><th></th></tr></thead>
              <tbody>
                {pending.map(q => (
                  <tr key={q.no}>
                    <td>{q.no}</td><td>{q.customer.name}</td><td className="r">{tl(q.total)}</td>
                    <td className="r">
                      <button className="btn" onClick={() => {
                        show('chat');
                        setTimeout(() => { const el = planEls.get(q.no); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 0);
                      }}>Taslağı aç</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></div>
          )}
      </div>
    </>
  );
}

export function QuotesView() {
  const { quotes } = useStore();
  return (
    <>
      <div className="page-title">Teklifler</div><p className="page-sub">Bu oturumda onaylanan teklifler. PDF'leri buradan tekrar indirebilirsiniz.</p>
      <div>
        {!quotes.length
          ? <div className="empty">Henüz onaylanmış teklif yok. İlk teklifinizi Komut merkezinden oluşturun.</div>
          : (
            <div className="tbl-wrap"><table className="num">
              <thead><tr><th>Teklif no</th><th>Müşteri</th><th>Tarih</th><th className="r">Tutar</th><th></th></tr></thead>
              <tbody>
                {quotes.map(q => (
                  <tr key={q.no}>
                    <td>{q.no}</td><td>{q.customer.name}</td><td>{q.createdAt}</td><td className="r">{tl(q.total)}</td>
                    <td className="r"><DownloadButton quote={q} /></td>
                  </tr>
                ))}
              </tbody>
            </table></div>
          )}
      </div>
    </>
  );
}

export function AuditView() {
  const { audit } = useStore();
  return (
    <>
      <div className="page-title">Denetim kaydı</div><p className="page-sub">Asistanın okuduğu, hesapladığı ve yazdığı her adım zaman damgasıyla tutulur.</p>
      <ul className="log">
        {!audit.length
          ? <li>Henüz kayıt yok.</li>
          : audit.map((a, i) => <li key={i}><time className="num">{a.t}</time><span>{a.text}</span></li>)}
      </ul>
    </>
  );
}
